import { fExecuteAPI } from "../../Server/Apis";
import {
  fAlertToast,
  fcheck_null_undefine_replace_empty,
} from "../../Utility/Utilitys";

import moment from "moment";
import { vRdxUserInfo, WmsPoPhysicalStockCountRo } from "../../Redux/roStore";
import { Set_SliceWmsPoPhysicalStockCount_HeadObject_A_DocStat } from "./SliceWmsPoPhysicalStockCount";
// item
export const GCToggleSearch_ItemName_Columns = [
  { field: "id", headerName: "ID", width: 70, hide: true },
  { field: "ItmCd", headerName: "ItmCd", width: 90 },
  { field: "Name1", headerName: "Name1", width: 450 },
  { field: "NameFL", headerName: "NameFL", width: 90 },
  { field: "MainGrpName", headerName: "MainGrpName", width: 90 },
  { field: "SuppRefNo1", headerName: "SuppRefNo1", width: 90 },
  { field: "Model", headerName: "Model", width: 90 },
  { field: "BaseUnitName", headerName: "BaseUnitName", width: 90 },
  { field: "BarCode", headerName: "BarCode", width: 90 },
];
export const GCToggleSearch_ItemName_Select_Arr = [
  "Any",
  "Code",
  "Barcode",
  "Name",
  "RefNo",
  "NameFL",
];

//customer
export const xGC_Toggle_Head_BinName_GridColumns = [
  { field: "id", headerName: "ID", width: 70, hide: true },
  { field: "UId", headerName: "Code", width: 90 },
  { field: "Name1", headerName: "Name1", width: 450 },
  { field: "BinAttr1", headerName: "BinAttr1", width: 450 },
  // { field: "Name1", headerName: "Name1", width: 220 },
];
export const xGC_Toggle_Head_BinName_DropDown_Arr = ["Any", "Code", "Name"];

export let Summary_Grid_Columns = [
  {
    field: "A_SheetId",
    headerName: "Sheet No",
    width: 150,
  },
  {
    field: "LocName",
    headerName: "Location",
    width: 200,
  },
  {
    field: "A_RefNo",
    headerName: "RefNo",
    width: 100,
  },
  {
    field: "A_Date",
    headerName: "Date",
    width: 100,
    valueFormatter: ({ value }) => moment(value).format("DD/MM/YYYY"),
  },
  {
    field: "A_POTyp",
    headerName: "POType",
    width: 100,
  },
  {
    field: "A_PONo",
    headerName: "PONo",
    width: 100,
  },
  {
    field: "POTypeName",
    headerName: "POTypeName",
    width: 150,
  },
  {
    field: "A_UserCd",
    headerName: "PDT UserCd",
    width: 300,
    hide: true,
  },
  {
    field: "Username",
    headerName: "Username",
    width: 100,
  },
  {
    field: "A_Status",
    headerName: "Status",
    width: 100,
  },
];
export const Detail_Grid_columns = [
  {
    field: "B_SheetId",
    headerName: "Sheet No",
    width: 150,
    hide: true,
  },
  {
    field: "B_SrNo",
    headerName: "Sr No",
    width: 50,
  },
  {
    field: "B_CardID",
    headerName: "CardID",
    width: 150,
  },
  {
    field: "B_ItmCd",
    headerName: "Item Code",
    width: 90,
    hide: true,
  },
  {
    field: "ItmName",
    headerName: "Item Name",
    width: 320,
  },
  {
    field: "B_BinCd",
    headerName: "BinCd",
    width: 50,
    hide: true,
  },
  {
    field: "BinName",
    headerName: "BinName",
    width: 300,
  },

  {
    field: "B_Qty",
    headerName: "Qty",
    width: 50,
  },
  {
    field: "B_Unit",
    headerName: "Unit",
    width: 100,
  },
  {
    field: "B_BaseQty",
    headerName: "Base Qty",
    width: 100,
  },
];
export const ErrorMsgDetail = {
  B_Srno: "", // int
  B_CardId: "",
  B_Itmcd: "",
  B_ItmName: "",
  B_BinCode: "",
  B_BinName: "",
  B_Qty: "", //Decimal
  B_Unit: "",
  B_UnitName: "",
  B_PackQty: "", //Decimal
  B_Packing: "", //Decimal
  B_BaseQty: "", //Decimal
};

export const sTrnTyp = "WMPOIPT01";

const GetItemFullSearchArr = async (xItemName, xLoc) => {
  let vItemFullSearchDataObj = {
    anyData: xItemName,
    transType: "F",
    report: "Y",
    loc: xLoc,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vItemFullSearchDataObj);

  const vItemSearchFull = await fExecuteAPI("SEARCHEXACTITEM_GETROW", FinalObj);
  if (vItemSearchFull?.Type?.toUpperCase() === "SUCCESS") {
    if (vItemSearchFull.ResultSet.length > 0) {
      return vItemSearchFull?.ResultSet;
    } else {
      return [];
    }
  } else {
    fAlertToast(
      "FAILED",
      vItemSearchFull?.Type?.response?.data?.message
        ? vItemSearchFull?.Type?.response?.data?.message
        : "Error in vItemSearchFullArr"
    );
    return [];
  }
};

const GetUnitArr = async (xItemCode, setUnit) => {
  let itemUnitobj = {
    itemCd: xItemCode,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(itemUnitobj);

  const UnitInfo = await fExecuteAPI("GETITEMUNITS_GETROW", FinalObj);
  if (UnitInfo?.Type?.toUpperCase() === "SUCCESS") {
    if (UnitInfo.ResultSet.length > 0) {
      setUnit(UnitInfo.ResultSet);
      return UnitInfo.ResultSet;
    } else {
      return [];
    }
  } else {
    fAlertToast(
      "FAILED",
      UnitInfo.Type.response.data.message
        ? UnitInfo.Type.response.data.message
        : "Error in UnitArr"
    );
    return [];
  }
};

const fItemCodeDependency = async (
  vItemSearchFull,
  setBufferObj,
  setUnit,
  defUnitValue = ""
) => {
  if (vItemSearchFull.length > 0) {
    setBufferObj((obj) => ({
      ...obj,
      B_Itmcd: vItemSearchFull[0].ItmCd,
      B_ItmName: vItemSearchFull[0].Name2,
      B_Barcode: vItemSearchFull[0].BarCode,
    }));
    let currentUnitArr = await GetUnitArr(vItemSearchFull[0].ItmCd, setUnit);

    if (currentUnitArr.length > 0) {
      let vItemUnitSet = currentUnitArr.find((obj) => {
        return obj.Unit === defUnitValue;
      });
      if (!!vItemUnitSet) {
        setBufferObj((obj) => ({
          ...obj,
          B_Unit: vItemUnitSet.Unit,
          B_UnitName: vItemUnitSet.Name1,
          B_PackQty: vItemUnitSet.PackQty,
          B_Packing: vItemUnitSet.PackDesc,
        }));
      } else {
        setBufferObj((obj) => ({
          ...obj,
          B_Unit: currentUnitArr[0].Unit,
          B_UnitName: currentUnitArr[0].Name1,
          B_PackQty: currentUnitArr[0].PackQty,
          B_Packing: currentUnitArr[0].PackDesc,
        }));
      }
      // let vItemUnitSet = currentUnitArr.find((obj) => {
      //   return obj.Unit === vItemSearchFull[0].DefUnit;
      // });
      // if (!!vItemUnitSet) {
      //   setBufferObj((obj) => ({
      //     ...obj,
      //     B_Unit: vItemUnitSet.Unit,
      //     B_UnitName: vItemUnitSet.Name1,
      //     B_PackQty: vItemUnitSet.PackQty,
      //   }));
      // } else {
      //   let vItemUnitSet = currentUnitArr.find((obj) => {
      //     return obj.Unit === vItemSearchFull[0].PurUOM;
      //   });
      //   if (!!vItemUnitSet) {
      //     setBufferObj((obj) => ({
      //       ...obj,
      //       B_Unit: vItemUnitSet.Unit,
      //       B_UnitName: vItemUnitSet.Name1,
      //       B_PackQty: vItemUnitSet.PackQty,
      //     }));
      //   } else {
      //     setBufferObj((obj) => ({
      //       ...obj,
      //       B_Unit: currentUnitArr[0].Unit,
      //       B_UnitName: currentUnitArr[0].Name1,
      //       B_PackQty: currentUnitArr[0].PackQty,
      //     }));
      //   }
      // }
    }
    setTimeout(() => {
      document
        .querySelector('.Mui-expanded [name="GC_Toggle_Head_BinName_Name"]')
        ?.focus();
    }, 100);
    // document.getElementsByName("GC_Toggle_Head_BinName_Name")[0]?.focus();
  } else {
    fAlertToast("FAILED", "Error in Exact Search");
  }
};

const GetSearchItem = async (xData, xType, xA_Loc, setSearchGridData) => {
  let vSeatchVendor = {
    Data: xData,
    Type: xType,
    Loc: xA_Loc,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vSeatchVendor);
  const vItemSearch = await fExecuteAPI("SEARCHITEM001_GETROW", FinalObj);
  if (vItemSearch?.Type?.toUpperCase() === "SUCCESS") {
    let vItemSearchArr = vItemSearch?.ResultSet.map((obj, i) => ({
      ...obj,
      id: i + 1,
    }));
    setSearchGridData(vItemSearchArr);
  } else {
    fAlertToast(
      "FAILED",
      vItemSearch.response.data.message
        ? vItemSearch.response.data.message
        : "Error in SearchItem"
    );
  }
};
const fValidationHead_Client = (
  vRdxHead,
  setErrorMsg,
  vMediaQuery,
  fSummary
) => {
  let iRes = true;
  // let xObjHasNullOrUndefinevale =
  //   fCheck_Value_Null_Or_Undefined_ShowAlert(vRdxHead);
  // fAlertToast("WARNING", xObjHasNullOrUndefinevale);
  if (
    vRdxHead.SheetNo === "" ||
    vRdxHead.SheetNo === null ||
    vRdxHead.SheetNo === undefined
  ) {
    if (vMediaQuery) {
      fSummary();
    }
    setErrorMsg((obj) => ({
      ...obj,
      SheetNo: "Sheet Number should not be empty",
    }));

    iRes = false;
  }

  if (
    vRdxHead.Loc === "" ||
    vRdxHead.Loc === null ||
    vRdxHead.Loc === undefined
  ) {
    if (vMediaQuery) {
      fSummary();
    }
    setErrorMsg((obj) => ({ ...obj, Loc: "Location should not be empty" }));
    iRes = false;
  }

  // default format so no need to check format
  if (
    vRdxHead.Date === "" ||
    vRdxHead.Date === null ||
    vRdxHead.Date === undefined
  ) {
    if (vMediaQuery) {
      fSummary();
    }
    setErrorMsg((obj) => ({
      ...obj,
      Date: "Date should not be empty",
    }));
    iRes = false;
  }

  if (
    vRdxHead.ReferenceNo === "" ||
    vRdxHead.ReferenceNo === null ||
    vRdxHead.ReferenceNo === undefined ||
    vRdxHead.ReferenceNo <= 0
  ) {
    if (vMediaQuery) {
      fSummary();
    }
    setErrorMsg((obj) => ({
      ...obj,
      ReferenceNo: "ReferenceNo should not be Empty",
    }));
    iRes = false;
  }

  // if (
  //   vRdxHead.PoType === "" ||
  //   vRdxHead.PoType === null ||
  //   vRdxHead.PoType === undefined
  // ) {
  //   if (vMediaQuery) {
  //     fSummary();
  //   }
  //   setErrorMsg((obj) => ({ ...obj, PoType: "PoType should not be empty" }));
  //   iRes = false;
  // }

  // if (
  //   vRdxHead.PoNo === "" ||
  //   vRdxHead.PoNo === null ||
  //   vRdxHead.PoNo === undefined
  // ) {
  //   if (vMediaQuery) {
  //     fSummary();
  //   }
  //   setErrorMsg((obj) => ({ ...obj, PoNo: "PoNo should not be empty" }));
  //   iRes = false;
  // }

  // if (
  //   vRdxHead.PDTUserCode === "" ||
  //   vRdxHead.PDTUserCode === null ||
  //   vRdxHead.PDTUserCode === undefined
  // ) {
  //   if (vMediaQuery) {
  //     fSummary();
  //   }
  //   setErrorMsg((obj) => ({
  //     ...obj,
  //     PDTUserCode: "PDTUserCode should not be empty",
  //   }));
  //   iRes = false;
  // }

  if (vRdxHead.A_DocStat !== "ENTER") {
    fAlertToast("FAILED", "Document status should be  Enter");
    iRes = false;
  }

  return iRes;
};

const fValidationDetail_Client = (sBufferObj, setErrorMsgDetail) => {
  let iRes = true;
  if (sBufferObj.B_Srno === "") {
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_Srno: "Serial number should not be empty",
    }));
    iRes = false;
    fAlertToast("FAILED", "Serial number should not be empty");
  }

  if (
    sBufferObj.B_CardId === "" ||
    sBufferObj.B_CardId === null ||
    sBufferObj.B_CardId === undefined
  ) {
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_CardId: "CardId should not be empty",
    }));
    iRes = false;
    fAlertToast("FAILED", "CardId should not be empty");
  }

  if (
    sBufferObj.B_BinCode === "" ||
    sBufferObj.B_BinCode === null ||
    sBufferObj.B_BinCode === undefined
  ) {
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_BinCode: "BinCode should not be empty",
    }));
    iRes = false;
    fAlertToast("FAILED", "BinCode should not be empty");
  }

  if (
    sBufferObj.B_BinName === "" ||
    sBufferObj.B_BinName === null ||
    sBufferObj.B_BinName === undefined
  ) {
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_BinName: "BinName should not be empty",
    }));
    iRes = false;
    fAlertToast("FAILED", "BinName should not be empty");
  }

  if (
    sBufferObj.B_Itmcd === "" ||
    sBufferObj.B_Itmcd === null ||
    sBufferObj.B_Itmcd === undefined
  ) {
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_Itmcd: "Item code should not be empty",
    }));
    iRes = false;
    fAlertToast("FAILED", "Item code should not be empty");
  }

  if (sBufferObj.B_ItmName === "") {
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_ItmName: "Item name should not be empty",
    }));
    iRes = false;
    fAlertToast("FAILED", "Item name should not be empty");
  }

  if (
    sBufferObj.B_Qty === "" ||
    Number(sBufferObj.B_Qty) <= 0 ||
    (sBufferObj.B_Qty === null) | (sBufferObj.B_Qty === undefined)
  ) {
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_Qty: "Qty should not be zero",
    }));
    iRes = false;
    fAlertToast("FAILED", "Qty should not be zero");
  }

  if (sBufferObj.B_Unit === "") {
    setErrorMsgDetail((obj) => ({ ...obj, B_Unit: "Select unit" }));
    iRes = false;
    fAlertToast("FAILED", "Select unit");
  } else if (sBufferObj.B_PackQty === "" || Number(sBufferObj.B_PackQty) <= 0) {
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_Unit: "Pack quantity should not be zero",
    }));
    iRes = false;
    fAlertToast("FAILED", "Pack quantity should not be zero");
  }

  return iRes;
};
//API SaveSIHead
const fSaveHead = async (fNewDetail, sBufferObj) => {
  const vRdxUserInfoObj = vRdxUserInfo();
  const { HeadObj } = WmsPoPhysicalStockCountRo(); //xSave False means Post
  let vSaveSIHeadObj = {
    A_POTyp: HeadObj.PoType,
    A_PONo: HeadObj.PoNo,
    A_SheetId: HeadObj.SheetNo,
    A_Loc: HeadObj.Loc,
    A_Date: moment(HeadObj.Date).format("MM/DD/YYYY"),
    A_Status: HeadObj.A_DocStat,
    A_RefNo: HeadObj.ReferenceNo,
    A_UserCd: HeadObj.PDTUserCode,
    UserCd: vRdxUserInfoObj.UserID,
    IP: vRdxUserInfoObj.IP,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vSaveSIHeadObj);
  const vSaveSIHead = await fExecuteAPI(
    "WMPOIPT01_poSaveHead_GETROW",
    FinalObj
  );
  if (vSaveSIHead?.Type?.toUpperCase() === "SUCCESS") {
    fSaveDetail(sBufferObj, fNewDetail);
  } else if (vSaveSIHead?.Type?.toUpperCase() === "FAILED") {
    fAlertToast("FAILED", vSaveSIHead.Status);
  } else {
    fAlertToast(
      "FAILED",
      !!vSaveSIHead.response.data.message
        ? vSaveSIHead?.response?.data?.message
        : "Fail to Save Head"
    );
  }
};

const fSaveDetail = async (sBufferObj, fNewDetail) => {
  const { HeadObj } = WmsPoPhysicalStockCountRo();

  let vSaveSIDetailObj = {
    B_SheetId: HeadObj.SheetNo,
    B_SrNo: sBufferObj.B_Srno,
    B_CardID: sBufferObj.B_CardId,
    B_BinCd: sBufferObj.B_BinCode,
    B_ItmCd: sBufferObj.B_Itmcd.trim(),
    B_Qty: sBufferObj.B_Qty,
    B_Unit: sBufferObj.B_Unit,
    B_BinName: sBufferObj.B_BinName,
    B_LocCd: HeadObj.Loc,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vSaveSIDetailObj);
  const vSaveSIDetail = await fExecuteAPI(
    "WMPOIPT01_poSaveDetail_GETROW",
    FinalObj
  );
  if (vSaveSIDetail?.Type?.toUpperCase() === "SUCCESS") {
    fNewDetail();
    fAlertToast("SUCCESS", "Successfully Saved");
  } else if (vSaveSIDetail?.Type?.toUpperCase() === "FAILED") {
    fAlertToast("FAILED", vSaveSIDetail?.Status);
  } else {
    fAlertToast("FAILED", vSaveSIDetail?.response?.data?.Status);
  }
};
const fApproveHead_Server = async (dispatch) => {
  const { HeadObj } = WmsPoPhysicalStockCountRo();

  let vApproveObj = {
    A_SheetId: HeadObj.SheetNo,
  };

  let FinalObj = fcheck_null_undefine_replace_empty(vApproveObj);
  const vApprove = await fExecuteAPI("WMPOIPT01_poApprove_GETROW", FinalObj);
  if (vApprove?.Type?.toUpperCase() === "SUCCESS") {
    dispatch(
      Set_SliceWmsPoPhysicalStockCount_HeadObject_A_DocStat({
        A_DocStat: "POST",
      })
    );
    fAlertToast("SUCCESS", "Successfully Approved");
  } else if (vApprove?.Type?.toUpperCase() === "FAILED") {
    fAlertToast("FAILED", vApprove?.Status);
  } else {
    fAlertToast("FAILED", vApprove?.response?.data?.message);
  }
};
const fReverseHead_Server = async (dispatch) => {
  const { HeadObj } = WmsPoPhysicalStockCountRo();

  let vReverseObj = {
    SheetId: HeadObj.SheetNo,
  };

  let FinalObj = fcheck_null_undefine_replace_empty(vReverseObj);
  const vReverse = await fExecuteAPI("WMPOIPT00A_REVERSAL", FinalObj);
  if (vReverse?.Type?.toUpperCase() === "SUCCESS") {
    dispatch(
      Set_SliceWmsPoPhysicalStockCount_HeadObject_A_DocStat({
        A_DocStat: "ENTER",
      })
    );
    fAlertToast("SUCCESS", "Successfully Reversed");
  } else {
    fAlertToast("FAILED", vReverse?.response?.data?.message);
  }
};
const GetSIDetail = async () => {
  const { HeadObj } = WmsPoPhysicalStockCountRo();
  let iSIDetailObj = {
    B_SheetId: HeadObj.SheetNo,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(iSIDetailObj);

  const iSIDetailResult = await fExecuteAPI(
    "WMPOIPT01_poGridLoad_GETROW",
    FinalObj
  );
  if (iSIDetailResult?.Type?.toUpperCase() === "SUCCESS") {
    if (iSIDetailResult?.ResultSet?.length > 0) {
      return iSIDetailResult.ResultSet;
    } else {
      return [];
    }
  } else if (iSIDetailResult?.Type?.toUpperCase() === "FAILED") {
    fAlertToast("FAILED", iSIDetailResult?.Status);
  } else {
    fAlertToast("FAILED", iSIDetailResult?.response?.data?.Status);
  }
};
const fLoad_Grid = async (setDetailGridData) => {
  const iSIDetail = await GetSIDetail();
  if (iSIDetail?.length > 0) {
    let GridID = iSIDetail?.map((obj, i) => ({
      ...obj,
      id: i + 1,
    }));
    setDetailGridData(GridID);
  } else {
    setDetailGridData([]);
  }
};

const GetPoTypeArr = async (setPoTypeArr) => {
  const UnitInfo = await fExecuteAPI("WMPOIPT01_PoType_GETROW");
  if (UnitInfo?.Type?.toUpperCase() === "SUCCESS") {
    if (UnitInfo.ResultSet.length > 0) {
      setPoTypeArr(UnitInfo.ResultSet);
    } else {
      setPoTypeArr([]);
    }
  } else {
    fAlertToast(
      "FAILED",
      UnitInfo.Type.response.data.message
        ? UnitInfo.Type.response.data.message
        : "Error in UnitArr"
    );
  }
};
const GetAccordionHeader = async ({ aisle }) => {
  const { HeadObj } = WmsPoPhysicalStockCountRo();
  let iSIDetailObj = {
    SheetId: HeadObj.SheetNo,
    Aisle: aisle,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(iSIDetailObj);

  const response = await fExecuteAPI("WMPOIPTItemGetRowHead", FinalObj);
  if (response?.recordset?.length > 0) {
    return response.recordset;
  } else {
    return [];
  }
};
const GetAisleRow = async () => {
  const { HeadObj } = WmsPoPhysicalStockCountRo();
  let iSIDetailObj = {
    SheetId: HeadObj.SheetNo,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(iSIDetailObj);

  const response = await fExecuteAPI("WMPOIPTItemGetAisleRow", FinalObj);
  if (response?.recordset?.length > 0) {
    return response.recordset;
  } else {
    return [];
  }
};
const GetAccordionRow = async ({ itemCode }) => {
  const { HeadObj } = WmsPoPhysicalStockCountRo();
  let iSIDetailObj = {
    SheetId: HeadObj.SheetNo,
    ItmCd: itemCode,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(iSIDetailObj);
  const iSIDetailResult = await fExecuteAPI("WMPOIPTItemGetRowInner", FinalObj);
  if (iSIDetailResult?.recordset?.length > 0) {
    return iSIDetailResult.recordset;
  } else {
    return [];
  }
};
export {
  GetItemFullSearchArr,
  GetUnitArr,
  GetPoTypeArr,
  fItemCodeDependency,
  GetSearchItem,
  fValidationDetail_Client,
  fValidationHead_Client,
  fLoad_Grid,
  fSaveHead,
  fApproveHead_Server,
  GetAccordionHeader,
  GetAccordionRow,
  GetAisleRow,
  fReverseHead_Server,
};
